// extracted by mini-css-extract-plugin
export default {"main_page":"RenaultSandero_main_page__73mDX","car_image":"RenaultSandero_car_image__qqPbm"};